export const appCdnURL = ""

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover"},{"name":"theme-color","content":"#ffffff"}],"link":[{"rel":"apple-touch-icon","sizes":"180x180","href":"https://app.medmastery.com/favicon/apple-touch-icon.png"},{"rel":"icon","type":"image/svg+xml","href":"https://app.medmastery.com/favicon/favicon.svg"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"https://app.medmastery.com/favicon/favicon-32x32.png"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"https://app.medmastery.com/favicon/favicon-16x16.png"},{"rel":"mask-icon","href":"https://app.medmastery.com/favicon/safari-pinned-tab.svg","color":"#5bbad5"},{"rel":"manifest","href":"https://app.medmastery.com/favicon/site.webmanifest"}],"style":[],"script":[{"id":"gtm","tagPosition":"head","tagPriority":0,"innerHTML":"\n    window.dataLayer = window.dataLayer || [];\n    function gtag() {\n      dataLayer.push(arguments);\n    }\n    gtag('consent', 'default', {\n      'ad_personalization': 'denied',\n      'ad_storage': 'denied',\n      'ad_user_data': 'denied',\n      'analytics_storage': 'denied',\n      'functionality_storage': 'denied',\n      'personalization_storage': 'denied',\n      'security_storage': 'granted',\n      'wait_for_update': 500,\n    });\n    gtag(\"set\", \"ads_data_redaction\", true);\n    gtag(\"set\", \"url_passthrough\", false);\n    "},{"tagPosition":"head","tagPriority":1,"innerHTML":"\n      function CookiebotCallback_OnAccept() {\n        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n            })(window,document,'script','dataLayer','GTM-NL5PR89');\n      }"},{"tagPosition":"head","tagPriority":2,"id":"cookiebot","src":"https://consent.cookiebot.com/uc.js","data-cbid":"7cd2a000-afab-4a5e-985f-eb7af42f15da","data-blockingmode":"none"},{"src":"https://status.medmastery.com/embed/script.js","tagPosition":"bodyClose","defer":true,"async":true},{"src":"https://bt.fraud0.com/api/v2/fz.js?cid=6e4a42bf-13da-424e-9a1e-d529434d1b2b","async":true,"tagPosition":"bodyOpen"}],"noscript":[],"title":"Medmastery"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true